import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import { select } from '@swf/core/store';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTCLI_Citizenship,
  TXTWCL_We_will_ask_you_for_this_infor_ELL_1,
  TXTWCL_WhatXs_your_citizenshipX
} from './RMFCitizenship.messages.json';
import { cnpWrapper, container, dropdownWrapper } from './RMFCitizenship.scss';
import CNP from './components/CNP/CNP';
import Citizenship from './components/Citizenship/Citizenship';
import OtherCitizenship from './components/OtherCitizenship/OtherCitizenship';
import SelectCitizenship from './components/SelectCitizenship/SelectCitizenship';

enum CitizenshipStep {
  Citizenship,
  Other
}

const RMFCitizenship: React.FC = () => {
  const [citizenshipStep, setCitizenshipStep] = useState<CitizenshipStep>();
  const isOtherSelected = citizenshipStep === CitizenshipStep.Other;
  const isCitizenshipSelected = citizenshipStep === CitizenshipStep.Citizenship;
  const siteId = useSelector(select.cms.getSiteId);
  const country = useSelector(select.account.getCountry);
  const showCNP = isCitizenshipSelected && siteId === Sites.ROM && country === Country.Romania;

  const handleCitizenshipSet = (citizenship: CitizenshipStep) => {
    if (citizenshipStep === citizenship) {
      return setCitizenshipStep(undefined);
    }

    setCitizenshipStep(citizenship);
  };

  return (
    <Container
      page={RMFCitizenship}
      headerProps={{
        title: <Translation {...TXTCLI_Citizenship} />
      }}
      pageTopTitle={<Translation {...TXTWCL_WhatXs_your_citizenshipX} />}
      pageTopSubtitle={<Translation {...TXTWCL_We_will_ask_you_for_this_infor_ELL_1} />}
    >
      <div className={container}>
        <Citizenship
          active={isCitizenshipSelected}
          handleClick={() => handleCitizenshipSet(CitizenshipStep.Citizenship)}
        />
        {showCNP && (
          <div className={cnpWrapper}>
            <CNP />
          </div>
        )}
        <OtherCitizenship
          active={isOtherSelected}
          handleClick={() => handleCitizenshipSet(CitizenshipStep.Other)}
        />
        {isOtherSelected && (
          <div className={dropdownWrapper}>
            <SelectCitizenship
              handleRomanianCitizenship={() => handleCitizenshipSet(CitizenshipStep.Citizenship)}
            />
          </div>
        )}
      </div>
      {(siteId === Sites.CA_ON ||
        [CitizenshipStep.Other, CitizenshipStep.Citizenship].includes(
          citizenshipStep as CitizenshipStep
        )) && <CTAButton />}
    </Container>
  );
};

RMFCitizenship.displayName = 'RMFCitizenship';

export default RMFCitizenship;
